import { render, staticRenderFns } from "./classparameters.vue?vue&type=template&id=711df6aa&scoped=true"
import script from "./classparameters.vue?vue&type=script&lang=js"
export * from "./classparameters.vue?vue&type=script&lang=js"
import style0 from "./classparameters.vue?vue&type=style&index=0&id=711df6aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711df6aa",
  null
  
)

export default component.exports